export default __webpack_public_path__ + "static/media/diamond-cut-2@3x.bc184469.png";